import React, { lazy } from 'react';
import { PublicRoute } from './components/PublicRoute';
import * as routesPaths from './RouteConstants';
// import WCStatistics from '../containers/Mundial2026/WCStatistics';
import TermsRouteView from '../modules/TermsRouteView';
import Landing from 'containers/Landing';
import NavigationWrapper from '../components/NavigationWrapper';
import Login from '../containers/Login';
import Register from '../containers/Register';
import { QRLinking } from 'containers/QRLinking';
import { QRLinkingAccount } from 'containers/QRLinking/QRLinkingAccount';
import { QRLinkingPaymentMethod } from 'containers/QRLinking/QRLinkingPaymentMethod';
import { QRLinkingCallCenter } from 'containers/QRLinking/QRLinkingCallCenter';
import { QRLinkingError } from 'containers/QRLinking/QRLinkingError';
import { QRLinkingErrorTriesExceeded } from 'containers/QRLinking/QRLinkingErrorTriesExceeded';
import { QRLinkingErrorTimeExceeded } from 'containers/QRLinking/QRLinkingErrorTimeExceeded';

//----LAZY ROUTES----
const Player = lazy(() => import('../providers/player.provider'));
const GTres = lazy(() => import('./../containers/GTres'));
const LoginCheckout = lazy(() =>
  import('../containers/Payment/LoginCheckout/index'),
);
const OauthCallbackView = lazy(() => import('./../modules/OauthCallbackView'));
const PlanSelect = lazy(() => import('../containers/Payment/PlanSelect'));
const Payment = lazy(() => import('../containers/Payment'));
const CompleteUser = lazy(() => import('../containers/CompleteUser'));
const ServiceRedirectView = lazy(() =>
  import('../modules/ios/ServiceRedirectView'),
);
const ForgottenPassword = lazy(() =>
  import('./../containers/ForgottenPassword'),
);
const PromoGateOnlyCode = lazy(() =>
  import('../containers/Payment/PromoGateOnlyCode'),
);
const PromoGateTicket = lazy(() =>
  import('../containers/Payment/ConfirmTransaction/ConfirmPromoGateTransaction'),
);
const RecoveryPassword = lazy(() => import('../containers/RecoveryPassword'));
const OTP = lazy(() =>
  import('./../containers/OTP').then(module => ({ default: module.OTP })),
);
const HBOActivationInput = lazy(() =>
  import('./../containers/HandlerActivateHbo').then(module => ({
    default: module.HandlerActivateHbo,
  })),
);
const HBOCommunication = lazy(() => import('./../containers/HboCommunication'));
const ExternalAppLogin = lazy(() => import('./../containers/AppLogin'));
const ExternalAppRegister = lazy(() => import('./../containers/AppRegister'));
const RecoveryPasswordCompleted = lazy(() =>
  import('./../containers/RecoveryPasswordCompleted'),
);
const TelmexAuthProvider = lazy(() =>
  import('./../components/TelmexAuthProvider'),
);
const LandingV2 = lazy(() => import('../containers/LandingV2'));
const PBIDeepLinkView = lazy(() => import('../modules/PBIDeepLinkView'));
const PaymentMobile = lazy(() => import('../containers/Payment/PaymentMobile'));
const PayPalReturnScreen = lazy(() =>
  import('../containers/Payment/PayPal/screens/PayPalReturnScreen'),
);
const PayPalCancelScreen = lazy(() =>
  import('../containers/Payment/PayPal/screens/PayPalCancelScreen'),
);

export const mainRoutes = [
  { path: routesPaths.COMPLETE_IPTV, element: <CompleteUser /> },
  { path: routesPaths.REDIRECT, element: <ServiceRedirectView /> },
  { path: routesPaths.PLAN_SELECT, element: <PlanSelect /> },
  { path: routesPaths.PAYMENT, element: <Payment /> },
  { path: routesPaths.OAUTH_CALLBACK, element: <OauthCallbackView /> },
  { path: routesPaths.CHECKOUT_REDIRECT, element: <LoginCheckout /> },
  { path: routesPaths.FORGOTTEN_PASSWORD, element: <ForgottenPassword /> },
  { path: routesPaths.LANDING, element: <PublicRoute component={Landing} /> },
  { path: routesPaths.LOGIN, element: <PublicRoute component={Login} /> },
  { path: routesPaths.PROMOGATE_ONLY_CODE, element: <PromoGateOnlyCode /> },
  {
    path: routesPaths.PLAYER,
    element: (
      <NavigationWrapper>
        <Player />
      </NavigationWrapper>
    ),
  },
  {
    path: routesPaths.GTRES,
    element: (
      <NavigationWrapper>
        <GTres />
      </NavigationWrapper>
    ),
  },
  {
    path: routesPaths.PROMOGATE_ONLY_CODE_CONFIRM,
    element: <PromoGateTicket />,
  },

  {
    path: routesPaths.REGISTER_FORM,
    element: <PublicRoute component={Register} />,
  },
  {
    path: routesPaths.RECOVERY_PASSWORD,
    element: <PublicRoute component={RecoveryPassword} />,
  },
  {
    path: routesPaths.RECOVERY_PASSWORD_COMPLETED,
    element: <PublicRoute component={RecoveryPasswordCompleted} />,
  },
  {
    path: routesPaths.OTP_TELMEX_REGISTER,
    element: <OTP />,
  },
  {
    path: routesPaths.OTP_REGISTER,
    element: <OTP />,
  },
  {
    path: routesPaths.OTP_LOGIN,
    element: <OTP />,
  },
  {
    path: routesPaths.HBO_ACTIVATION,
    element: <HBOActivationInput />,
  },
  {
    path: routesPaths.HBO_COMMUNICATION,
    element: <HBOCommunication />,
  },
  {
    path: routesPaths.EXTERNAL_APP_LOGIN,
    element: <ExternalAppLogin />,
  },
  {
    path: routesPaths.EXTERNAL_APP_REGISTER,
    element: <ExternalAppRegister />,
  },
  {
    path: routesPaths.EXTERNAL_APP_LANDING,
    element: <LandingV2 />,
  },
  {
    path: '/telmex/auth/loader',
    element: <TelmexAuthProvider />,
  },
  {
    path: '/telmex/auth/callback',
    element: <TelmexAuthProvider />,
  },
  {
    path: routesPaths.PAYMENT_MOBILE,
    element: <PaymentMobile />,
  },
  {
    path: routesPaths.PBI_DEEPLINK,
    element: <PBIDeepLinkView />,
  },
  {
    path: routesPaths.QR_LINKING,
    element: <QRLinking />,
  },
  // QR_LINKING_EDIT monta el mismo componente que QR_LINKING a propósito, por
  // pedido de negocio: ambas rutas deben cargar el mismo flujo, no dos
  // variantes de "agregar" vs "editar".
  {
    path: routesPaths.QR_LINKING_EDIT,
    element: <QRLinking />,
  },
  {
    path: routesPaths.QR_LINKING_ACCOUNT,
    element: <QRLinkingAccount />,
  },
  {
    path: routesPaths.QR_LINKING_PAYMENT_METHOD,
    element: <QRLinkingPaymentMethod />,
  },
  {
    path: routesPaths.QR_LINKING_CALL_CENTER,
    element: <QRLinkingCallCenter />,
  },
  {
    path: routesPaths.QR_LINKING_LINKING_ERROR,
    element: <QRLinkingError />,
  },
  {
    path: routesPaths.QR_LINKING_LINKING_EXCEEDED_TRIES,
    element: <QRLinkingErrorTriesExceeded />,
  },
  {
    path: routesPaths.QR_LINKING_LINKING_ERROR_TIME_EXCEEDED,
    element: <QRLinkingErrorTimeExceeded />,
  },
  // PayPal return / cancel routes
  {
    path: routesPaths.PAYPAL_TVOD_CONFIRM,
    element: <PayPalReturnScreen />,
  },
  {
    path: routesPaths.PAYPAL_PURCHASE_CHECKOUT_RETURN,
    element: <PayPalReturnScreen />,
  },
  {
    path: routesPaths.PAYPAL_PURCHASE_CHECKOUT_CANCEL,
    element: <PayPalCancelScreen />,
  },
  {
    path: routesPaths.PAYPAL_SVOD_RETURN_URL,
    element: <PayPalReturnScreen />,
  },
  {
    path: routesPaths.PAYPAL_SUBSCRIPTION_CHECKOUT_RETURN,
    element: <PayPalReturnScreen />,
  },
  {
    path: routesPaths.PAYPAL_SUBSCRIPTION_CHECKOUT_CANCEL,
    element: <PayPalCancelScreen />,
  },
];
